import router from '../router/index'
import store from "../store/store";

import { axios, BaseUrl, BaseApiUrl, BaseOpenApiUrl } from './axios_config';

export const ToLogin = params => {

    store.commit('user/saveToken', "")
    store.commit('user/saveTokenExpire', "")
    store.commit('user/saveTagsData', "")

    // store_user.commit("saveToken", "");
    // store_user.commit("saveTokenExpire", "");
    // store_user.commit("saveTagsData", "");

    window.localStorage.removeItem('user');
    window.localStorage.removeItem('NavigationBar');

    if (global.IS_IDS4) {
        applicationUserManager.login();
    } else {
        router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
        });

        window.location.reload()
    }
};

// 登录
export const requestLogin = params => {
    return axios.get(`${BaseApiUrl}/auth/getjwttoken`, { params: params }).then(res => res.data);
};

export const requestLoginMock = params => { return axios.post(`${BaseApiUrl}/login`, params).then(res => res.data); };

export const refreshToken = params => {
    return axios.get(`${BaseApiUrl}/auth/RefreshToken`, { params: params }).then(res => res.data);
};

export const saveRefreshtime = params => {

    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

    let refreshCount = 1;//滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    } else {
        window.localStorage.refreshtime = new Date(-1);
    }
};

export const getUserByToken = params => {
    console.log(params);
    return axios.post(`${BaseApiUrl}/user/getInfoByToken`, params).then(res => res.data);
};


export function testapi2() {
    console.log('api is ok.')
}

export const testapi = pa => {
    console.log('api is ok.')
}

//组织管理
export const getOrganizationListPage = params => {
    return axios.get(`${BaseApiUrl}/organization/get`, { params: params });
};
export const addOrganization = params => {
    return axios.post(`${BaseApiUrl}/organization/post`, params);
};
export const editOrganization = params => {
    return axios.post(`${BaseApiUrl}/organization/put`, params);
};
export const removeOrganization = params => {
    return axios.delete(`${BaseApiUrl}/organization/delete`, { params: params });
};

// 用户管理
export const getUserListPage = params => {
    return axios.get(`${BaseApiUrl}/user/get`, { params: params });
};
export const removeUser = params => {
    return axios.delete(`${BaseApiUrl}/user/delete`, { params: params });
};
export const editUser = params => {
    return axios.post(`${BaseApiUrl}/user/put`, params);
};
export const resetUser = params => {
    return axios.post(`${BaseApiUrl}/user/Reset`, params);
};
export const editUserPass = params => {
    return axios.post(`${BaseApiUrl}/user/changePass`, params);
};
export const addUser = params => {
    return axios.post(`${BaseApiUrl}/user/post`, params);
};

// 角色管理
export const getRoleListPage = params => {
    return axios.get(`${BaseApiUrl}/role/get`, { params: params });
};
export const removeRole = params => {
    return axios.delete(`${BaseApiUrl}/role/delete`, { params: params });
};
export const editRole = params => {
    return axios.post(`${BaseApiUrl}/role/put`, params);
};
export const addRole = params => {
    return axios.post(`${BaseApiUrl}/role/Post`, params);
};

// 接口模块管理
export const getModuleListPage = params => {
    return axios.get(`${BaseApiUrl}/module/get`, { params: params });
};
export const removeModule = params => {
    return axios.delete(`${BaseApiUrl}/module/delete`, { params: params });
};
export const editModule = params => {
    return axios.post(`${BaseApiUrl}/module/put`, params);
};
export const addModule = params => {
    return axios.post(`${BaseApiUrl}/module/post`, params);
};
export const exportModule = params => {
    return axios.get(`${BaseApiUrl}/module/export`, params, { responseType: 'blob' }).then((res) => {
        var content = res.data;
        var blob = new Blob([content]);
        var fileName = "apis.xlsx"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
            // 非IE下载
            var elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
        } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
        }
    }).catch((err) => {
        console.error(err);
    });
};


// 菜单模块管理
export const getPermissionListPage = params => {
    return axios.get(`${BaseApiUrl}/permission/get`, { params: params });
};
export const getPermissionTreeTable = params => {
    return axios.get(`${BaseApiUrl}/permission/GetTreeTable`, { params: params });
};
export const removePermission = params => {
    return axios.delete(`${BaseApiUrl}/permission/delete`, { params: params });
};
export const editPermission = params => {
    return axios.post(`${BaseApiUrl}/permission/put`, params);
};
export const addPermission = params => {
    return axios.post(`${BaseApiUrl}/permission/post`, params);
};
export const getPermissionTree = params => {
    return axios.get(`${BaseApiUrl}/permission/getpermissiontree`, { params: params });
};
export const getPermissionIds = params => {
    return axios.get(`${BaseApiUrl}/permission/GetPermissionIdByRoleId`, { params: params });
};

export const addRolePermission = params => {
    return axios.post(`${BaseApiUrl}/permission/Assign`, params);
};
export const addUserDataPermission = params => {
    return axios.post(`${BaseApiUrl}/user/Assign`, params);
};
export const getNavigationBar = params => {
    return axios.get(`${BaseApiUrl}/permission/GetNavigationBar`, { params: params }).then(res => res.data);
};


// 日志
export const getLogs = params => {
    return axios.get(`${BaseApiUrl}/Monitor/get`, { params: params });
};
export const getRequestApiinfoByWeek = params => {
    return axios.get(`${BaseApiUrl}/Monitor/GetRequestApiinfoByWeek`, { params: params });
};
export const getAccessApiByDate = params => {
    return axios.get(`${BaseApiUrl}/Monitor/GetAccessApiByDate`, { params: params });
};
export const getAccessApiByHour = params => {
    return axios.get(`${BaseApiUrl}/Monitor/GetAccessApiByHour`, { params: params });
};
export const getServerInfo = params => {
    return axios.get(`${BaseApiUrl}/Monitor/Server`, { params: params });
};
export const getAccessLogs = params => {
    return axios.get(`${BaseApiUrl}/Monitor/GetAccessLogs`, { params: params });
};
export const getIds4UsersGrow = params => {
    return axios.get(`${BaseApiUrl}/Monitor/GetIds4Users`, { params: params });
};
export const getActiveUsers = params => {
    return axios.get(`${BaseApiUrl}/Monitor/GetActiveUsers`, { params: params });
};


// Task管理
export const getTaskListPage = params => {
    return axios.get(`${BaseApiUrl}/TaskQz/Get`, { params: params });
};
export const removeTask = params => {
    return axios.delete(`${BaseApiUrl}/TaskQz/delete`, { params: params });
};
export const editTask = params => {
    return axios.post(`${BaseApiUrl}/TaskQz/put`, params);
};
export const addTask = params => {
    return axios.post(`${BaseApiUrl}/TaskQz/post`, params);
};

export const startJob = params => {
    return axios.get(`${BaseApiUrl}/TaskQz/StartJob`, { params: params });
};
export const stopJob = params => {
    return axios.get(`${BaseApiUrl}/TaskQz/StopJob`, { params: params });
};
export const reCovery = params => {
    return axios.get(`${BaseApiUrl}/TaskQz/ReCovery`, { params: params });
};
export const pauseJob = params => {
    return axios.get(`${BaseApiUrl}/TaskQz/PauseJob`, { params: params });
};
export const resumeJob = params => {
    return axios.get(`${BaseApiUrl}/TaskQz/ResumeJob`, { params: params });
};

// ids4
export const getAchieveUsers_IS4 = params => {
    return axios.get(`${BaseApiUrl}/is4api/GetAchieveUsers`, { params: params });
};

//查询操作日志
export const getbusinessLog = params => {
    return axios.get(`${BaseApiUrl}/WareHouse/BusinessLogServices`, { params: params });
};

//查询国家
export const getCountryList = params => {
    return axios.get(`${BaseApiUrl}/Util/GetCountryList`, { params: params });
};

//查询省市联动
export const getStateCityAreaTree = params => {
    return axios.get(`${BaseApiUrl}/Util/GetStateCityAreaTree`, { params: params });
};

export const getWarehouseByOrg = params => {
    return axios.get(`${BaseApiUrl}/util/getWarehouseList`, { params });
};


// 仓库维护
//加载基础资料
export const getWarehousebase = params => {
    return axios.get(`${BaseApiUrl}/WareHouse/GetWarehousebase`, { params: params });
};

//新增
export const addWarehouse = params => {
    return axios.post(`${BaseApiUrl}/WareHouse/AddWarehouse`, params);
};
//查询
export const getWarehouseList = params => {
    return axios.get(`${BaseApiUrl}/WareHouse/GetWarehouse`, { params: params });
};

//修改
export const editWarehouse = params => {
    return axios.post(`${BaseApiUrl}/WareHouse/EditWarehouse`, params);
};
//启用禁用
export const editWarehouseStatus = params => {
    return axios.post(`${BaseApiUrl}/WareHouse/EditWarehouseStatus`, params);
};

//查询仓库详情
export const getWarehouseQueryById = params => {
    return axios.get(`${BaseApiUrl}/WareHouse/GetWarehouseQueryById`, { params: params });
};
//导出
export const exportWarehouse = params => {

    return axios({
        url: `${BaseApiUrl}/WareHouse/ExportWarehouse`,
        method: "get",
        params: params,
        responseType: 'blob',
    })
        .then((res) => {
            var content = res.data;
            console.log(res)
            var blob = new Blob([content]);
            console.log(blob)
            let fileName = "仓库导出.xlsx";
            let blobObject = new Blob([content], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            //是IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {//火狐谷歌都兼容
                //模板中要有一个预定义好的a标签
                var elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blobObject);
                elink.setAttribute('download', fileName)
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }

        }).catch((err) => {
            console.error(err);

        });

};


// 库区维护
//加载基础资料
export const getWarehouseAreabase = params => {
    return axios.get(`${BaseApiUrl}/WarehouseArea/GetWarehouseAreabase`, { params: params });
};
//查询库区详情
export const getWarehouseAreaQueryById = params => {
    return axios.get(`${BaseApiUrl}/WarehouseArea/GetWarehouseAreaQueryById`, { params: params });
};

//新增
export const addWarehouseArea = params => {
    return axios.post(`${BaseApiUrl}/WarehouseArea/AddWarehouseArea`, params);
};
//查询
export const getWarehouseAreaList = params => {
    return axios.get(`${BaseApiUrl}/WarehouseArea/GetWarehouseArea`, { params: params });
};
//修改
export const editWarehouseArea = params => {
    return axios.post(`${BaseApiUrl}/WarehouseArea/EditWarehouseArea`, params);
};
//启用禁用
export const editWarehouseAreaStatus = params => {
    return axios.post(`${BaseApiUrl}/WarehouseArea/EditWarehouseAreaStatus`, params);
};

//导出
export const exportWarehouseArea = params => {

    return axios({
        url: `${BaseApiUrl}/WarehouseArea/ExportWarehouse`,
        method: "get",
        params: params,
        responseType: 'blob',
    })
        .then((res) => {
            var content = res.data;
            console.log(res)
            var blob = new Blob([content]);
            console.log(blob)
            let fileName = "库区导出.xlsx";
            let blobObject = new Blob([content], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            //是IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {//火狐谷歌都兼容
                //模板中要有一个预定义好的a标签
                var elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blobObject);
                elink.setAttribute('download', fileName)
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }

        }).catch((err) => {
            console.error(err);

        });

};

// 托盘管理
//新增
export const addWarehousePallet = params => {
    return axios.post(`${BaseApiUrl}/WarehousePallet/AddWarehousePallet`, params);
};
//查询
export const getWarehousePalletList = params => {
    return axios.get(`${BaseApiUrl}/WarehousePallet/GetWarehousePallet`, { params: params });
};
//查询详情
export const getWarehousePalletQueryById = params => {
    return axios.get(`${BaseApiUrl}/WarehousePallet/GetWarehousePalletQueryById`, { params: params });
};


//修改
export const editWarehousePallet = params => {
    return axios.post(`${BaseApiUrl}/WarehousePallet/EditWarehousePallet`, params);
};
//启用禁用
export const editWarehousePalletStatus = params => {
    return axios.post(`${BaseApiUrl}/WarehousePallet/EditWarehousePalletStatus`, params);
};

//导出
export const exportWarehousePallet = params => {

    return axios({
        url: `${BaseApiUrl}/WarehousePallet/ExportWarehousePallet`,
        method: "get",
        params: params,
        responseType: 'blob',
    })
        .then((res) => {
            var content = res.data;
            console.log(res)
            var blob = new Blob([content]);
            console.log(blob)
            let fileName = "托盘导出.xlsx";
            let blobObject = new Blob([content], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            //是IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {//火狐谷歌都兼容
                //模板中要有一个预定义好的a标签
                var elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blobObject);
                elink.setAttribute('download', fileName)
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }

        }).catch((err) => {
            console.error(err);

        });

};

//下载托盘标签
export const downloadWarehousePalletLabel = params => {
    return axios.get(`${BaseApiUrl}/WarehousePallet/DownloadWarehousePalletLabel`, { params: params });
};



//导入
export const importWarehousePallet = `${BaseApiUrl}/WarehousePallet/ImportWarehousePallet`;

//导出模板
export const downloadWarehousePallet = `${BaseUrl}/template/warehouse/托盘导入模板.xlsx`;



// 库位维护
//加载基础资料
export const getWarehouseLocationbase = params => {
    return axios.get(`${BaseApiUrl}/WarehouseLocation/GetWarehouseLocationbase`, { params: params });
};
//新增
export const addWarehouseLocation = params => {
    return axios.post(`${BaseApiUrl}/WarehouseLocation/AddWarehouseLocation`, params);
};
//查询
export const getWarehouseLocationList = params => {
    return axios.get(`${BaseApiUrl}/WarehouseLocation/GetWarehouseLocation`, { params: params });
};
//查询详情
export const getWarehouseLocationQueryById = params => {
    return axios.get(`${BaseApiUrl}/WarehouseLocation/GetWarehouseLocationQueryById`, { params: params });
};

//修改
export const editWarehouseLocation = params => {
    return axios.post(`${BaseApiUrl}/WarehouseLocation/EditWarehouseLocation`, params);
};
//启用禁用
export const editWarehouseLocationStatus = params => {
    return axios.post(`${BaseApiUrl}/WarehouseLocation/EditWarehouseLocationStatus`, params);
};

//导出
export const exportWarehouseLocation = params => {

    return axios({
        url: `${BaseApiUrl}/WarehouseLocation/ExportWarehouseLocation`,
        method: "get",
        params: params,
        responseType: 'blob',
    })
        .then((res) => {
            var content = res.data;
            console.log(res)
            var blob = new Blob([content]);
            console.log(blob)
            let fileName = "库位导出.xlsx";
            let blobObject = new Blob([content], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            //是IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {//火狐谷歌都兼容
                //模板中要有一个预定义好的a标签
                var elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blobObject);
                elink.setAttribute('download', fileName)
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }

        }).catch((err) => {
            console.error(err);

        });

};
//导入
export const importWarehouseLocation = `${BaseApiUrl}/WarehouseLocation/ImportWarehouseLocation`;

//导出模板
export const downloadWarehouseLocation = `${BaseUrl}/template/warehouse/库位导入模板.xlsx`;

//下载库位条码
export const downloadWarehouseLocationLabel = params => {
    return axios.get(`${BaseApiUrl}/WarehouseLocation/DownloadWarehouseLocationLabel`, { params: params });
};



//入库管理
//加载基础资料
export const getTWDeliveryInfoDepartment = params => {
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetTWDeliveryInfoDepartment`, { params: params });
};
//操作人员
export const getOperatorInfo = params => {
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetOperatorInfo`, { params: params });
};
//入库查询
export const getTWDeliveryInfoQueryList = params => {
    return axios.post(`${BaseApiUrl}/InventoryQuery/GetTWDeliveryInfoQueryList`, params);
};
//导出
export const getTWDeliveryInfoQueryOut = `${BaseApiUrl}/InventoryQuery/GetTWDeliveryInfoQueryOut`;
//完结入库单
export const editTWDeliveryInfoStatus = params => {
    return axios.post(`${BaseApiUrl}/InventoryQuery/EditTWDeliveryInfoStatus`, params);
};
//打印sku
export const printDeliveryInfoSku = params => {
    return axios.post(`${BaseApiUrl}/InventoryQuery/PrintDeliveryInfoSku`, params);
};

///批次库存查询
//批次库存查询
export const getBatchesInventoryAsync = params => {
    return axios.post(`${BaseApiUrl}/InventoryReport/GetBatchesInventoryAsync`, params);
};
//导出
export const exportbatchesInventoryOut = `${BaseApiUrl}/InventoryReport/BatchesInventoryOut`;


///出入库明细查询
//查询
export const getInventoryDetailAsync = params => {
    return axios.post(`${BaseApiUrl}/InventoryReport/GetInventoryDetailAsync`, params);
};
//导出
export const exportInventoryDetailOut = `${BaseApiUrl}/InventoryReport/InventoryDetailOut`;


///盘点库明细查询
//查询盘点状态
export const getInventoryCheckStatus = params => {
    return axios.get(`${BaseApiUrl}/InventoryReport/GetInventoryCheckStatus`, { params: params });
};
//查询
export const getInventoryCheckAsync = params => {
    return axios.post(`${BaseApiUrl}/InventoryReport/GetInventoryCheckAsync`, params);
};
//导出
export const exportInventoryCheckOut = `${BaseApiUrl}/InventoryReport/InventoryCheckOut`;


///文件处理
//查询文件
export const getUploadFileInfoBySourceID = params => {
    return axios.get(`${BaseApiUrl}/File/GetUploadFileInfoBySourceID`, { params: params });
};
//下载压缩文件
export const getUploadFileReviewImagesFileOut = `${BaseApiUrl}/File/GetUploadFileReviewImagesFileOut`;

//查询平面图
export const getWarehouseFloorPlanList = params => {
    return axios.get(`${BaseApiUrl}/WareHouse/GetWarehouseFloorPlan`, { params: params });
};

// 获取版本号
export const getVersion = params => {
    return axios.get(`${BaseOpenApiUrl}/Machine/GetPDAVersion`, { params: params });
};
export const getPDAFile = `${BaseOpenApiUrl}/Machine/GetPDAUpdateFile`